<div class="mb-3 mt-3 border-bottom ">
  <ul class="arrive-info">
    <li class="text-small"><p>Arrive :</p> <b>
    <p class="left-label">{{quote?.checkInDate | date:'EE, MMM d, yyyy'}}<br>4:00pm or later<br>Staying
    {{quote?.numberOfNightsStay}} Nights </p>
  </b></li>
  <li class="text-small"><p>Depart :</p> <b>
  <p class="left-label">{{quote?.checkOutDate | date:'EE, MMM d, yyyy'}}<br>11:00am or earlier</p>
</b></li>
<li class="text-small"><p>Property :</p>
<b>
  <p class="left-label">
    {{quote?.shortTermRental?.development?.adrDevelopmentName}}
    <br />
    {{quote?.shortTermRental?.propertyCode}}
    <br />
    {{quote?.shortTermRental?.development?.adrStreetNumber}}
    {{quote?.shortTermRental?.development?.adrStreetName}}
    <br />
    {{quote?.shortTermRental?.development?.adrCity}},
    {{quote?.shortTermRental?.development?.adrState}}
    {{quote?.shortTermRental?.development?.adrPostalCode}}
  </p>
</b>
</li>

<li class="text-small"><p>Guests :</p> <b>
<p class="left-label">{{quote?.numAdults}} Adults<br> {{quote?.numChildren}} Children<br> {{quote?.numPets}} Pets</p>
</b></li>
</ul>
<div class="table-responsive- reservation-invoice-table">
  <table class="table mb-0 text-center price-table table-striped">
    <thead>
      <tr>
        <th scope="col" style="padding-left: 4px; text-align: left;">Desc</th>
        <th scope="col">Qnt</th>
        <th scope="col" style="padding-left: 4px; text-align: left;">Price</th>
      </tr>
    </thead>
    <tbody>
      @for (invoice of quote?.invoice?.invoiceDetails; track invoice) {
        <tr>
          @if (!invoice.productName.includes('Coupon Discount')) {
            <td>{{invoice.productName}}
              @if (invoice.productName == 'Nightly rate') {
                <span>
                  <span style="text-decoration:line-through">{{calculateDiscount(invoice.finalPrice, 32.2)}}</span>
                  <br><span style="color:green">Discount applied&nbsp;(<b>-32.2%</b>)</span></span>
                }
              </td>
            }
            <!-- <td style="color: green;" *ngIf="invoice.productName.include('Coupon Discount')">{{invoice.productName}}
          </td> -->
          @if (invoice.productName.includes('Coupon Discount')) {
            <td style="color: green;">{{invoice.productName}}</td>
          }
          <td>{{invoice.quantity}}</td>
          <td class="text-start">{{formatCurrency(invoice.finalPrice)}}</td>
        </tr>
      }
      <tr class="empty-row">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr class="bold-row">
        <td>Subtotal :</td>
        <td></td>
        <td class="text-start">{{formatCurrency(quote?.invoice?.grandTotal)}}</td>
      </tr>
      <tr class="bold-row">
        <td>Tax : </td>
        <td></td>
        <td class="text-start">{{formatCurrency(quote?.invoice?.totalTax)}}</td>
      </tr>
      <tr class="bold-row">
        <td>Total : </td>
        <td></td>
        <td class="text-start">{{formatCurrency(quote?.invoice?.grandTotalWithTax)}}</td>
      </tr>
      <tr class="bold-row">
        <td><a (click)="showCouponDialog()" style="font-size: xx-small;color: blue;">+ Coupon?</a></td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
  </table>
</div>
</div>


@if (!showShortInvoiceDetail) {
  <div class="pb-3 mb-3 border-bottom sidebar-widget m-detail-popup d-none d-md-block">
    <h4 class="mb-2 widget-title">Payment Schedule</h4>
    <div class="table-responsive">
      <table class="table mb-0 text-center table-striped payment-shedule-book-table">
        <thead>
          <tr>
            <th scope="col">Payment</th>
            <th scope="col">Amount</th>
            <th scope="col">Due Date</th>
          </tr>
        </thead>
        <tbody>
          @for (invoice of quote?.invoice?.paymentSchedules; track invoice) {
            <tr>
              <td>{{invoice.productName}}</td>
              <td>{{formatCurrency(invoice.finalPrice)}}</td>
              <td class="text-center">{{invoice.dueDate | date}}</td>
            </tr>
          }
          <tr>
            <td></td>
          </tr>
          @for (invoice of quote?.invoice?.paymentSchedules; track invoice) {
            <tr>
              <td colspan="3" class="text-start">{{invoice.publicNotes}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}
@if (!showShortInvoiceDetail) {
  <div class="pb-3 mb-3 border-bottom sidebar-widget d-none d-md-block">
    <h4 class="mb-2 widget-title">Cancellation Policy</h4>
    <p class="mt-2 mb-0 payment-info-desc">{{quote?.invoice?.cancellationPolicy}}</p>
  </div>
}
@if (!showShortInvoiceDetail) {
  <div class="sidebar-widget d-none d-md-block">
    <div class="lease-aggrement-box">
      <p style="width:100%" [innerHTML]="quote?.rentalAgreement?.replaceAll('\n','\<br\>')"></p>
      @if (isValidReservation) {
        <p><img src={{reservation.contract.signBase64}} alt="" /></p>
      }
      @if (isValidReservation) {
        <p><label>[PRINT FIRST AND LAST NAME] : </label> {{reservation.contract.signName}}
      </p>
    }
    @if (isValidReservation) {
      <p><label>Date Time : </label> {{reservation.contract.signDate}}</p>
    }
    @if (isValidReservation) {
      <p><label>Signature Digital ID : </label> {{reservation.contract.signDigId}}</p>
    }
  </div>
</div>
}